import styled from 'styled-components';

const FlatButton = styled.button.attrs({type: 'button'})`
  color: ${({theme}) => theme.primaryColor};
  border: 0;
  background: none;
  box-shadow: none;
  border-radius: 0;
  cursor: pointer;
  padding: ${({theme}) => theme.spacingVertical()} ${({theme}) => theme.spacingHorizontal()};
  font-size: ${({theme}) => theme.fontMedium};
`;

export default FlatButton;
